module.exports = __webpack_public_path__ + "static/media/kubernetes.277e0ec2.png";